import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

interface ProLockedOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProLockedOverlay = ({ isOpen, onClose }: ProLockedOverlayProps) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="w-[85%] max-w-sm rounded-3xl p-6 text-center shadow-2xl border border-primary/20"
        style={{ background: "linear-gradient(180deg, hsl(280, 50%, 12%), hsl(0, 0%, 6%))" }}
      >
        <div className="w-16 h-16 rounded-full gradient-vibrant mx-auto mb-4 flex items-center justify-center shadow-xl">
          <Lock className="w-7 h-7 text-primary-foreground" />
        </div>
        <h3 className="text-xl font-display font-bold text-foreground mb-2">Pro Feature</h3>
        <p className="text-sm text-muted-foreground mb-5">
          Unlock all filters and premium features with a Pro subscription!
        </p>
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={() => { onClose(); navigate("/shop"); }}
          className="w-full py-3.5 rounded-2xl gradient-vibrant text-primary-foreground font-display font-bold glow-vibrant shadow-lg flex items-center justify-center gap-2"
        >
          <Crown className="w-4 h-4" />
          Get Pro
        </motion.button>
        <button
          onClick={onClose}
          className="mt-3 text-sm text-muted-foreground"
        >
          Maybe later
        </button>
      </motion.div>
    </motion.div>
  );
};

export default ProLockedOverlay;
